import React, { useState, useEffect } from "react";
import { Container } from "react-bootstrap";
import Footer from "./footer";
import DashboardNavbar from "./DashboardNavbar";
import { getData } from "../api/protectedApi";
import ReactPaginate from "react-paginate";
import "../style.css";
import {
  FaSpinner,
  FaUserPlus,
  FaChevronLeft,
  FaChevronRight,
} from "react-icons/fa6";
import { Link } from "react-router-dom";
import {
  FaLifeRing,
  FaSitemap ,
  FaHandHoldingUsd,
  FaCoins,
  FaChartBar,
  FaMoneyBillWave,
} from "react-icons/fa";
import { toast } from "react-toastify";




const PoolIncome = () => {
  const [userName, setUserName] = useState("");
  const [dashboard, setDashboard] = useState({});
  const [incomeData, setIncomeData] = useState([]);
  const [totalPages, setTotalPages] = useState(0);
  const [currentPage, setCurrentPage] = useState(0);

  const perPage = 10;

  const getIncomeData = async (page = 0) => {
    try {
      setCurrentPage(page);
      const res = await getData(
        `/pool_income?per_page=${perPage}&page=${page + 1}`
      );
      setIncomeData(res?.data?.data || []);
      setTotalPages(res?.data?.pagination?.total_pages || 0);
    } catch (err) {
      console.error(err);
    }
  };


  const getUserProfile = async () => {
    try {
      const res = await getData("/profile");
      if (res?.data?.user_data?.name) {
        setUserName(res.data.user_data.name);
      }
    } catch (error) {
      console.error("Failed to fetch user data", error);
    }
  };
  const loadData = async () => {
    try {
      const res = await getData("/dashboard");
      if (res?.data?.data) {
        setDashboard(res.data.data);
      }
    } catch (error) {
      toast.error("Failed to load dashboard");
    }
  };

  useEffect(() => {
    getIncomeData();
    getUserProfile();
    loadData()
  }, []);




  return (
    <div
      style={{
        backgroundColor: "#0d0e13",
        minHeight: "100vh",
        color: "#ffffff",
        paddingTop: "12px",
      }}
    >
      {/* Navbar */}
      <DashboardNavbar />
      {/* HEADER */}
      <section>
        <div className="container pt-5">
          <div className="mb-4">
            <div className="welcome">Welcome to Hifi Internationals</div>
            <div className="hello">
              Hello, {userName || "User"}
            </div>

          </div>
        </div>
      </section>

      {/* POOL INFO */}
      <section>
        <div
          className="container-fluid py-3"
          style={{ backgroundColor: "#141245" }}
        >
          <div className="container">
            <div className="mb-4">
              <div className="hifi1-race-label">Active : $30</div>
              <div className="hifi1-race-title">Activation Pool</div>
            </div>

            <div className="row g-4">
              <div className="col-lg-3 col-md-6 col-12">
                <div className="hifi1-pool-card">
                  <div className="hifi1-icon blue">
                    <FaSpinner size={40} />
                  </div>
                  <div className="hifi1-card-label">Pool Status</div>
                  <div className="hifi1-card-value">
                    {dashboard?.pool_status}
                  </div>
                </div>
              </div>

              <div className="col-lg-3 col-md-6 col-12">
                <div className="hifi1-pool-card">
                  <div className="hifi1-icon blue">
                    <FaUserPlus size={40} />
                  </div>
                  <div className="hifi1-card-label">Total Referrals</div>
                  <div className="hifi1-card-value">
                    {dashboard?.directs || 0}
                  </div>
                </div>
              </div>

              <div className="col-lg-3 col-md-6 col-12">
                <div className="hifi1-pool-card">
                  <div className="hifi1-icon orange">
                    <FaMoneyBillWave size={40} />
                  </div>
                  <div className="hifi1-card-label">Referral Bonus</div>
                  <div className="hifi1-card-value">
                    {dashboard?.directIncome || 0}
                  </div>
                </div>
              </div>

              <div className="col-lg-3 col-md-6 col-12">
                <div className="hifi1-pool-card">
                  <div className="hifi1-icon darkblue">
                    <FaChartBar size={40} />
                  </div>
                  <div className="hifi1-card-label">Pool Bonus</div>
                  <div className="hifi1-card-value">
                    {dashboard?.poolIncome || 0}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* QUICK LINKS */}
      <section className="hifi1section py-5">
        <div className="container">
          <div className="row g-4 justify-content-center hifi1section-2">

            <div className="col-xl-3 col-lg-4 col-md-6">
              <Link to="/poolinfo" className="text-decoration-none">
                <div className="hifi-card hifi1-icon darkblue">
                  <FaLifeRing size={40} />
                  <span>POOL INFO</span>
                </div>
              </Link>
            </div>

            <div className="col-xl-3 col-lg-4 col-md-6">
              <Link to="/levelincome" className="text-decoration-none">
                <div className="hifi-card hifi1-icon darkblue">
                  <FaSitemap  size={40} />
                  <span>LEVEL INCOME</span>
                </div>
              </Link>
            </div>

            <div className="col-xl-3 col-lg-4 col-md-6">
              <Link to="/directincome" className="text-decoration-none">
                <div className="hifi-card hifi1-icon darkblue">
                  <FaHandHoldingUsd size={40} />
                  <span>REFERRAL INCOME</span>
                </div>
              </Link>
            </div>

            <div className="col-xl-3 col-lg-4 col-md-6">
              <Link to="/poolincome" className="text-decoration-none">
                <div className="hifi-card hifi1-icon darkblue">
                  <FaCoins size={40} />
                  <span>POOL INCOME</span>
                </div>
              </Link>
            </div>

          </div>
        </div>
      </section>


      {/* TABLE */}
      <section className="pb-5">
        <div className="container directs-wrapper">
          <div className="directs-title">Pool Income</div>

          <div className="table-responsive">
            <table className="table directs-table align-middle">
              <thead>
                <tr>
                  <th></th>
                  <th>#</th>
                  <th>Amount</th>
                  <th>Hash</th>
                  <th></th>
                  <th>Date</th>
                </tr>
              </thead>
              <tbody>
                {incomeData.length === 0 ? (
                  <tr>
                    <td colSpan="6" className="text-center text-white">
                      No records found
                    </td>
                  </tr>
                ) : (
                  incomeData.map((item, index) => (
                    <tr key={item.id || index}>
                      <td></td>
                      <td>{currentPage * perPage + index + 1}</td>
                      <td>{item.amount}</td>
                      <td>{item.hash}</td>
                      <td></td>
                      <td>{item.Date}</td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>

          {/* PAGINATION */}
          {totalPages > 1 && (
            <ReactPaginate
              forcePage={currentPage}
              previousLabel={<FaChevronLeft />}
              nextLabel={<FaChevronRight />}
              pageCount={totalPages}
              onPageChange={(e) => getIncomeData(e.selected)}
              containerClassName="pagination custom-pagination justify-content-center"
              pageClassName="page-item"
              pageLinkClassName="page-link"
              previousClassName="page-item"
              previousLinkClassName="page-link"
              nextClassName="page-item"
              nextLinkClassName="page-link"
              activeClassName="active"
            />

          )}
        </div>
      </section>

      <Footer />
    </div>
  );
};

/* SMALL COMPONENT */
const SummaryCard = ({ icon, label, value }) => (
  <div className="col-lg-3 col-md-6 col-12">
    <div className="hifi1-pool-card">
      <div className="hifi1-icon">{icon}</div>
      <div className="hifi1-card-label">{label}</div>
      <div className="hifi1-card-value">{value}</div>
    </div>
  </div>
);

export default PoolIncome;
